import { render, staticRenderFns } from "./headTab.vue?vue&type=template&id=7aa5fa77&scoped=true&"
import script from "./headTab.vue?vue&type=script&lang=js&"
export * from "./headTab.vue?vue&type=script&lang=js&"
import style0 from "./headTab.vue?vue&type=style&index=0&id=7aa5fa77&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa5fa77",
  null
  
)

export default component.exports